import styled from 'styled-components';
import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';

export const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ScrollableContainer = styled.div`
  justify-content: center;
  align-items: center;
  overflow-x: auto;
  @media ${DEVICES.laptop} {
    width: 70%;
  }
  @media ${DEVICES.mobileL} {
    width: 90%;
  }
`;

export const ScrollableHeader = styled.header`
  display: flex;
  overflow-x: auto;
  background-color: ${COLORS.dividerBlue};
  border-radius: 20px;
  padding: 24px;
`;

export const StepContainer = styled.div`
  display: flex;
  min-width: 200px;
  max-width: 200px;
  border-right: 1px solid ${COLORS.borderLightBlue};
  padding: 0px 16px 0px 16px;
  &:last-child {
    border-right: none;
  }
`;

export const StepNumberWrapper = styled.div`
  min-width: 24px;
  margin-top: 16px;
`;

export const StepNumber = styled.div`
  width: 24px;
  height: 24px;
  background-color: ${COLORS.white};
  color: ${COLORS.black};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  margin-top: 12%;
  padding-bottom: 2px;
`;

export const StepText = styled.div`
  margin-left: 8px;
`;

export const Heading = styled.h1`
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 14px;
  font-style: normal;
  line-height: 26px;
  text-align: start;
`;

export const SubHeading = styled.p`
  color: ${COLORS.bodyColor};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
